<template>
  <div id="publicClass_order">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="hotgkt_bj">
      <div class="order_Steps">
        <div class="ul">
          <div class="stepsT">
            <strong
              ><span class="left"></span><span class="right"></span
            ></strong>
          </div>
          <div class="li" :class="{ side: side1 }">订单确认</div>
          <div class="li" :class="{ side: side2 }">订单支付</div>
          <div class="li" :class="{ side: side3 }">购买成功</div>
        </div>
      </div>
      <!-- order_Steps end -->
      <div class="order_content">
        <div class="order_xx">
          <dl class="clearfix">
            <dt><img :src="dataText.CoverImg" /></dt>
            <dd>
              <h2>{{ dataText.Title }}</h2>
              <p class="bq" v-if="dataText.ApplyStudentName">
                <span>适合学生：</span>#{{
                  dataText.ApplyStudentName.replace(/,/g, "#")
                }}
              </p>
              <p><span>授课时间：</span>{{ dataText.BeginTime }}</p>
              <p><span>授课老师：</span>{{ dataTextName }}</p>
            </dd>
          </dl>
          <p class="zfje">
            支付金额<span>￥{{ dataText.Price }}</span>
          </p>
        </div>
        <!-- order_xx end -->
        <div class="order_zf">
          <p class="zs">
            注：提交订单后，我们会在“我的订单-待支付”中为您保留30分钟的支付时间。
          </p>
          <div class="yd clearfix">
            <el-checkbox v-model="checked" @change="changeD"
              >我已阅读并接受
              <router-link :to="{ path: '/agreement1_yhzx' }" target="_blank"
                >《启德考培在线用户协议》</router-link
              >
            </el-checkbox>
          </div>
          <div class="clearfix an">
            <span v-if="!checked">提交订单</span>
            <span class="tjdd" v-else @click="pay">提交订单</span>
            <span class="qxdd" @click="back">取消订单</span>
          </div>
        </div>
        <!-- order_zf end -->
      </div>
      <!-- order_content end -->
    </div>
    <!-- hotgkt_bj end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header
  },
  data() {
    return {
      tokenkey: "",
      side1: true,
      side2: false,
      side3: false,
      checked: false,
      dataText: "",
      dataBox: "",
      dataTextName: "",
      money: "",
      Orders: "",
      Ordertime: ""
    };
  },
  methods: {
    changeD() {
      // console.log(this.checked)
    },
    pay() {
      let that = this;
      let classId = that.$route.query.id;
      this.$http
        .post(
          "https://schoolapi.eiceducation.com.cn/api/OpenCourseOrder",
          {
            OpenCourseId: classId
          },
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          if (result.data.code == 200) {
            that.money = result.data.results.Money;
            that.Orders = result.data.results.OrderNumber;
            that.Ordertime = result.data.results.CreateTime;

            that.$router.push({
              path: "/publicClass_pay",
              query: {
                moneytext: that.money,
                Orderstext: that.Orders
              }
            });
            // 离开支付页面30倒计时继续
            // if(localStorage.getItem('kcdd')){
            //   return;
            // } else {
            // }
            localStorage.setItem("kcdd", that.Ordertime);
          }
        })
        .catch(function(error) {
          // console.log(error);
        });
    },
    back() {
      this.$router.go(-1);
    }
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    if (!this.$cookies.isKey("token")) {
      this.$router.push("/index");
    }
    that.tokenkey = that.$cookies.get("token");
    localStorage.getItem("data");
    that.dataText = JSON.parse(localStorage.getItem("data"));
    that.dataTextName = that.dataText.Staff[0].Name;
    // console.log(that.dataText)
  }
};
</script>

<style scoped>
.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt_bj {
  background: #fafafa;
  padding-top: 20px;
  padding-bottom: 110px;
}

.order_Steps {
  width: 1180px;
  height: 120px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  margin-bottom: 16px;
}

.order_Steps .ul {
  width: 658px;
  height: 77px;
  padding-top: 22px;
  margin: 0 auto;
  display: -webkit-flex;
  justify-content: space-between;
  display: flex;
  position: relative;
}

.order_Steps .ul .li {
  display: inline-block;
  width: 110px;
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #999999;
  background: url(../../assets/publicClass/icon_JD-B.png) top no-repeat;
  text-align: center;
  padding-top: 61px;
  position: relative;
  z-index: 5;
}

.order_Steps .ul .li.side {
  background-image: url(../../assets/publicClass/icon_JD-A.png);
  color: #333333;
}

.order_Steps .ul .stepsT {
  width: 600px;
  height: 5px;
  background: #f6f6f6;
  border-radius: 3px;
  position: absolute;
  left: 29px;
  top: 65px;
  padding-top: 1px;
}

.order_Steps .ul .stepsT strong {
  display: block;
  width: 150px;
  height: 4px;
  background: #ff7e7e;
  border-radius: 3px;
}

.order_Steps .ul .stepsT strong span {
  width: 6px;
  height: 6px;
  background: #ff7e7e;
  border-radius: 3px;
  margin-top: -1px;
}

.order_Steps .ul .stepsT strong .left {
  margin-left: -1px;
}

.order_content {
  width: 1180px;
  height: 435px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
}

.order_xx {
  width: 1080px;
  padding-top: 27px;
  margin: 0 auto;
  border-bottom: 1px #d5d5d5 solid;
}

.order_xx dl {
  min-height: 187px;
}

.order_xx dl dt {
  width: 190px;
  height: 120px;
  background: #ff9494;
  border-radius: 8px;
  float: left;
  margin-right: 16px;
}
.order_xx dl dt img {
  width: 190px;
  height: 120px;
  border-radius: 5px;
}

.order_xx dl dd {
  width: 874px;
  float: left;
  text-align: left;
}

.order_xx dl dd h2 {
  font-size: 16px;
  line-height: 24px;
  color: #333;
  margin-bottom: 5px;
}

.order_xx dl dd p {
  font-size: 12px;
  line-height: 24px;
  color: #666666;
}

.order_xx dl dd p.bq {
  color: #ff9d00;
}

.order_xx dl dd p span {
  display: inline-block;
  text-align: right;
  width: 64px;
  font-size: 12px;
  color: #666;
}

.order_xx .zfje {
  text-align: right;
  font-size: 16px;
  color: #333;
  line-height: 20px;
  padding-bottom: 13px;
  font-weight: bold;
}

.order_xx .zfje span {
  font-size: 16px;
  color: #ff3953;
}

.order_zf {
  width: 1080px;
  margin: 0 auto;
}

.order_zf .zs {
  text-align: right;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  margin-bottom: 8px;
}

.order_zf .yd {
  text-align: right;
}

.order_zf .yd a {
  color: #ff4256;
}

.order_zf .an {
  float: right;
  padding: 20px 0;
}

.order_zf .an span {
  display: block;
  width: 120px;
  height: 38px;
  background: #f5f6f6;
  border-radius: 23px;
  float: right;
  margin-right: 12px;
  font-size: 16px;
  color: #999;
  line-height: 38px;
  text-align: center;
  cursor: pointer;
}

.order_zf .an .tjdd {
  display: block;
  width: 120px;
  height: 38px;
  background: linear-gradient(90deg, #ff7c71 0%, #ff3250 100%);
  border-radius: 23px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page2/publicClass/publicClass_order.vue